import React from 'react';

import AppBar from 'components/AppBar';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import Details from 'components/AutoDetails';
import Loader from 'components/Loader';
import ModalHeader from 'components/ModalHeader';
import { Desktop, Mobile } from 'components/Responsive';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { VehicleOption } from 'models/auto/vehicle';
import { VehicleValidateResponse } from 'models/auto/vehicleValidate';
import SolicitationSuccess from 'screens/components/SolicitationSuccess';
import { TravelArrangerUsersAllowed } from 'services/userService';
import { htmlT } from 'utils/generic';

import { Container, Body } from './styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export interface Props {
  show: boolean;
  creating: boolean;
  loading: boolean;
  details?: VehicleValidateResponse;
  optionId: string;
  onConfirm: (
    auto: VehicleValidateResponse,
    justifyForBreakingRules: string,
    reason: string,
    costCenterId?: string,
    breakRulesMessageId?: string,
    card?: string
  ) => void;
  onClose: () => void;
  showChurning: boolean;
  setShowChurning: (show: boolean) => void;
  showSuccess: boolean;
  list?: VehicleOption[];
  onSelectAgency?: (id?: string) => void;
  unlimitedKm?: boolean;
  traveler?: TravelArrangerUsersAllowed;
}

const AutoDetails = ({
  show,
  creating,
  loading,
  details,
  optionId,
  onClose,
  onConfirm,
  showChurning,
  setShowChurning,
  showSuccess,
  list,
  onSelectAgency,
  unlimitedKm = false,
  traveler,
}: Props) => {
  const { t } = useStoreTranslation();
  const isMobile = useIsMobile();
  const travel_itinerary_id = useSelector((state: RootState) => state.travel.travelItineraryId);

  const renderContent = () => {
    if (details) {
      return (
        <>
          <Body>
            <Details
              breakRulesMessage={details.breakRulesMessage}
              creating={creating}
              showChurning={showChurning}
              setShowChurning={setShowChurning}
              details={details}
              onClose={onClose}
              onConfirm={onConfirm}
              list={list}
              onSelectAgency={onSelectAgency}
              optionId={optionId}
              show={show}
              unlimitedKm
            />
          </Body>
          <SolicitationSuccess show={showSuccess} isHotel={false} isFlight={false} testId="auto-solicitation-success" tid={travel_itinerary_id} />
        </>
      );
    }
  };

  return (
    <ApplicationOverlayContent show={show} width={600} onClose={onClose} testId="auto-details">
      <Container>
        <Mobile>
          <AppBar goBack={onClose}>{t('autosDetails.title')}</AppBar>
        </Mobile>

        <Desktop>
          <ModalHeader
            onClose={onClose}
            title={t('autosDetails.title')}
            subtitle={
              traveler ? (
                <>{htmlT(t, 'autosSearch.toTraveler', { user: `${traveler.name} ${traveler.lastName}` })}</>
              ) : undefined
            }
          />
        </Desktop>

        {loading ? <Loader fullScreen={isMobile} /> : renderContent()}
      </Container>
    </ApplicationOverlayContent>
  );
};

export default AutoDetails;
